import { Component, Input, OnChanges, Renderer2 } from '@angular/core';
import { SEOService } from 'src/app/services/seo.service';

export interface FaqItem {
  question: string;
  answer: string;
  open: boolean;
}

@Component({
  selector: 'currency-faqs',
  templateUrl: './currency-faqs.component.html',
  styleUrls: ['./currency-faqs.component.scss'],
  standalone: false
})
export class CurrencyFaqsComponent implements OnChanges {
  @Input() content: string;

  faqItems: FaqItem[] = [];
  fallbackContent: string;

  constructor(private seoService: SEOService, private renderer: Renderer2) {}

  ngOnChanges(): void {
    const openState = new Map(this.faqItems.map(item => [item.question, item.open]));
    this.faqItems = this.parseFaqs(this.content);
    if (openState.size) {
      this.faqItems.forEach(item => {
        if (openState.has(item.question)) {
          item.open = openState.get(item.question);
        }
      });
    }
    this.fallbackContent = this.faqItems.length ? null : this.content;
    if (this.faqItems.length) {
      this.seoService.addFaqSchema(this.renderer, this.faqItems);
    }
  }

  toggle(item: FaqItem): void {
    item.open = !item.open;
  }

  private parseFaqs(html: string): FaqItem[] {
    if (!html) return [];

    const container = document.createElement('div');
    container.innerHTML = html;

    const items: FaqItem[] = [];
    const listItems = container.querySelectorAll('li');

    let currentQuestion: string = null;

    listItems.forEach(li => {
      const strong = li.querySelector('strong');
      if (strong) {
        if (currentQuestion) {
          items.push({ question: currentQuestion, answer: '', open: false });
        }
        currentQuestion = strong.textContent.trim();
        // Check if answer is in the same li (after the strong tag)
        const remainingText = li.textContent.replace(strong.textContent, '').trim();
        if (remainingText) {
          items.push({ question: currentQuestion, answer: remainingText, open: false });
          currentQuestion = null;
        }
      } else if (currentQuestion) {
        items.push({ question: currentQuestion, answer: li.innerHTML.trim(), open: false });
        currentQuestion = null;
      }
    });

    if (currentQuestion) {
      items.push({ question: currentQuestion, answer: '', open: false });
    }

    if (items.length) {
      items[0].open = true;
    }
    return items;
  }
}
